import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ModuleSettingsCampusLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ModuleSettingsCampus' */ './components/ModuleSettingsCampus'
		)
);

export default (store) => {
	return {
		path: ':campusId',
		element: <AsyncLoading component={<ModuleSettingsCampusLazy />} />,
	};
};
